/**
 * "Költség rögzítése" — the dashed button that opens the expense sheet, the
 * sheet itself, and the confirmation once it has gone through. One component
 * for both places a driver logs a receipt: the day screen (free-standing) and
 * a trip (then `bookingId` ties the receipt to that booking).
 */
import React, { useCallback, useState } from 'react';
import { EXPENSE_COPY } from '../portalFormat';
import ExpenseSheet from './ExpenseSheet';
import Toast from './Toast';
import { ReceiptIcon } from './Icons';

/** `copy`: the driver's Hungarian by default (EXPENSE_COPY), English on the operator screens. */
export default function RecordExpense({
  bookingId = '', tripLabel = '', onSaved, copy = EXPENSE_COPY,
}) {
  const [open, setOpen] = useState(false);
  const [toast, setToast] = useState('');

  const close = useCallback(() => setOpen(false), []);
  const clearToast = useCallback(() => setToast(''), []);
  const saved = useCallback((expense) => {
    setToast(copy.saved);
    if (onSaved) onSaved(expense);
  }, [copy, onSaved]);

  return (
    <>
      <button
        type="button"
        className="pp-btn pp-btn--dashed pp-btn--block"
        onClick={() => setOpen(true)}
      >
        <ReceiptIcon size={18} />
        {bookingId ? copy.recordForTrip : copy.record}
      </button>

      {open ? (
        <ExpenseSheet
          bookingId={bookingId}
          tripLabel={tripLabel}
          onClose={close}
          onSaved={saved}
          copy={copy}
        />
      ) : null}

      <Toast message={toast} onDone={clearToast} />
    </>
  );
}
